import { TournamentShortDto } from '@features/landing/grandprix/typings';

type Props = {
  tournament: Pick<TournamentShortDto, 'system'>;
};

export function TournamentSystem({ tournament }: Props) {
  if (tournament.system === 'Swiss') {
    return 'Швейцарская система';
  }

  if (tournament.system === 'RoundRobin') {
    return 'Круговая система';
  }

  return null;
}
